import { backendRequest } from '../shared/vasiBackend';

/**
 * Report scoring queue for cloud evals, served by vasi-backend. vasi-admin
 * makes no Firestore reads or writes for it. The backend joins
 * cloud_eval_results with clients and organizations, drops internal-org and
 * orphan evals and those whose eval_reviews/{id} is "scored", and sorts
 * oldest first (undated last).
 */

// Fired after an eval is marked scored so the nav badge can refresh.
export const EVAL_REVIEWS_CHANGED_EVENT = 'vasi:eval-reviews-changed';

const QUEUE_PATH = '/admin/report-queue';

export async function loadReportQueue(options = {}) {
  const body = await backendRequest(QUEUE_PATH, options);
  return Array.isArray(body?.items) ? body.items : [];
}

export async function loadUnscoredReportCount(options = {}) {
  const body = await backendRequest(`${QUEUE_PATH}/count`, options);
  const count = Number(body?.count);
  if (!Number.isFinite(count)) throw new Error('The report queue count was not a number.');
  return count;
}

/**
 * Mark an eval done. The backend merges eval_reviews/{evaluationId} with
 * status "scored" and looks up client, org and case number itself.
 */
export async function markEvalScored({ evaluationId, token, baseUrl, fetchImpl } = {}) {
  if (!evaluationId) {
    throw new Error('Cannot mark an eval scored without an evaluation id.');
  }
  return backendRequest(`${QUEUE_PATH}/${encodeURIComponent(evaluationId)}/done`, {
    method: 'POST',
    token,
    baseUrl,
    fetchImpl,
  });
}

export function reportQueuePath(evaluationId) {
  return evaluationId ? `/report/${encodeURIComponent(evaluationId)}` : '/report';
}
